import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { GlobalContext } from '../contexts/GlobalContext';

const useStyles = makeStyles({
	root: {
		minWidth: 205,
		borderRadius: 12,
		textAlign: 'center',
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)',
	},
	title: {
		fontSize: 18,
		fontWeight: 700,
		marginBottom: 0,
	},
	topContent: {
		padding: '8px',
		backgroundColor: '#dfe2e8',
	},
	pos: {
		marginBottom: 12,
	},
	boxCount: {
		borderRight: '1px solid rgba(0, 0, 0, 0.08)',
	},
	statLabel: {
		fontSize: 18,
		marginBottom: 4,
		fontWeight: 500,
		fontFamily:
			'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
		margin: 0,
	},
	statValue: {
		fontSize: 20,
		fontWeight: 'bold',
		marginBottom: 4,
		letterSpacing: '1px',
	},
});

var dict = {};
dict['CS'] = 'Code System';
dict['VS'] = 'Value Set';
dict['CM'] = 'Concept Map';
dict['RS'] = 'Ref Sets';
dict['NS'] = 'Naming System';

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const StatsCard = (props) => {
	const { cat } = props;
	const gc = useContext(GlobalContext);

	const [resType] = useState(cat);
	const [activeCount, setActiveCount] = useState(0);
	const [draftCount, setDraftCount] = useState(0);

	const classes = useStyles();
	useEffect(() => {
		var dict = {};
		dict['CS'] = 'CodeSystem';
		dict['VS'] = 'ValueSet';
		dict['CM'] = 'ConceptMap';
		dict['NS'] = 'NamingSystem';

		if (gc.server !== '') {
			var status = 'active';
			var query = dict[resType] + '?status=' + status + '&_summary=count';
			var qUrl = gc.server + query;
			fetch(qUrl)
				.then((response) => response.json())
				.then((data) => {
					// console.log(data.total);
					setActiveCount(data.total);
				});

			status = 'draft';
			query = dict[resType] + '?status=' + status + '&_summary=count';
			qUrl = gc.server + query;
			fetch(qUrl)
				.then((response) => response.json())
				.then((data) => {
					// console.log(data.total);
					setDraftCount(data.total);
				});
		} else {
			setDraftCount('--');
			setActiveCount('--');
		}
	}, [resType, gc.server]);

	return (
		<Card variant="outlined" className={classes.root}>
			<CardContent className={classes.topContent}>
				<Typography
					className={classes.title}
					color="textSecondary"
					gutterBottom
				>
					{dict[cat]}
				</Typography>
			</CardContent>
			{/* <Card variant="outlined" className={classes.root}> */}
			<Divider light />
			<Box display={'flex'}>
				<Box p={2} flex={'0.5'} className={classes.boxCount}>
					<p className={classes.statLabel}>Active</p>
					<p className={classes.statValue}>{numberWithCommas(activeCount)}</p>
				</Box>
				<Divider light />
				<Box p={2} flex={'0.5'}>
					<p className={classes.statLabel}>Draft</p>
					<p className={classes.statValue}>{numberWithCommas(draftCount)}</p>
				</Box>
			</Box>
		</Card>
	);
};

export default StatsCard;
